import React from 'react'
import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {

    render() {
        const { changeHandler, checkedHandler, saveHandler, Model, List, ListLocationLevel, ListLocation2, ShowModal, handleValidation, cancelHandler, errors, Mode } = this.props

        return (

            <div class="mb-10">
                {/* {JSON.stringify(errors)} */}

                <Modal show={ShowModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                        {/* {JSON.stringify(errors)} */}
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-12">

                            <label for="location_level_name" class="form-label lebar formInput">Level Lokasi*</label>
                            <select class="form-select lebar abu" style={{ height: 40 }} id="location_level" value={Model.location_level_id} onChange={changeHandler('location_level_id')}>
                                <option selected hidden>--pilih--</option>
                                {ListLocationLevel.map(data => {
                                    return (
                                        <option value={data._id}>{data.name}</option>
                                    )
                                })}
                            </select>
                            <span className="error">{errors["location_level"]}</span>
                            <br></br>

                            <label for="parent" class="form-label formInput">Wilayah</label>
                            <select class="form-select lebar abu" style={{ height: 40 }} id="parent" value={Model.parent_id} onChange={changeHandler('parent_id')}>
                                <option selected hidden>--pilih--</option>
                                {ListLocation2.map(data2 => {
                                    return (
                                        <option value={data2._id}>{data2.abbreviation} {data2.name}, {data2.abb_parent} {data2.parent}</option>
                                    )
                                })}
                            </select>
                            <span className="error">{errors["parent"]}</span>
                            <br></br>

                            <label for="name" class="form-label formInput">Nama *</label>
                            <input type="name" class="form-control" id="name" value={Model.name} onChange={changeHandler("name")}></input>
                            <span className="error" class="error">{errors["name_existed"]}</span>
                            <span className="error" class="error">{errors["name"]}</span>
                            <span className="error" class="error">{errors["name2"]}</span>
                            <span className="error" class="error">{errors["nameEmpty"]}</span>
                            <span className="error" class="error">{errors["nameEmpty2"]}</span>


                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Submit</button>
                        <button type="button" class="btn btn-primary" onClick={cancelHandler}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
